/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fastest lap and overtake bonuses — All bonus points are captured from the official results.`)
};

const es_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonos de vuelta rápida y adelantamientos — Todos los puntos de bono se capturan de los resultados oficiales.`)
};

const de_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellste Runde und Überholboni — Alle Bonuspunkte werden aus den offiziellen Ergebnissen erfasst.`)
};

const nl_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snelste ronde- en inhaalbonussen — Alle bonuspunten worden vastgelegd uit de officiële resultaten.`)
};

const fr_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus de tour le plus rapide et dépassements — Tous les points bonus sont capturés à partir des résultats officiels.`)
};

const it_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus giro veloce e sorpassi — Tutti i punti bonus vengono acquisiti dai risultati ufficiali.`)
};

const pt_br2_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bônus de volta mais rápida e ultrapassagens — Todos os pontos de bônus são capturados dos resultados oficiais.`)
};

const pt_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bónus de volta mais rápida e ultrapassagens — Todos os pontos de bónus são captados dos resultados oficiais.`)
};

const ja_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファステストラップとオーバーテイクボーナス — すべてのボーナスポイントは公式結果から取得。`)
};

const zh_about_scoring_bonuses = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最快圈速和超车奖励 — 所有奖励积分均从官方结果中获取。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_scoring_bonuses = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_scoring_bonuses(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_scoring_bonuses", locale)
	if (locale === "en") return en_about_scoring_bonuses(inputs)
	if (locale === "es") return es_about_scoring_bonuses(inputs)
	if (locale === "de") return de_about_scoring_bonuses(inputs)
	if (locale === "nl") return nl_about_scoring_bonuses(inputs)
	if (locale === "fr") return fr_about_scoring_bonuses(inputs)
	if (locale === "it") return it_about_scoring_bonuses(inputs)
	if (locale === "pt-BR") return pt_br2_about_scoring_bonuses(inputs)
	if (locale === "pt") return pt_about_scoring_bonuses(inputs)
	if (locale === "ja") return ja_about_scoring_bonuses(inputs)
	return zh_about_scoring_bonuses(inputs)
};